// eslint-disable-next-line max-classes-per-file
class Question {
  constructor(object) {
    this.object = object;
  }

  asObject() {
    return this.object;
  }

  getPatch(index) {
    return index;
  }
}

class MetaQuestion extends Question {
  constructor(field, object) {
    super(object);
    this.field = field;
  }

  getPatch(index) {
    return {
      [this.field]: this.object.values[index],
    };
  }
}

class QuestionsList {
  constructor(questions) {
    this.questions = metaQuestions.concat(questions.map((q) => new Question(q)));

    this.metaQuestionsLength = metaQuestions.length;

    this.currentQuestion = -1;
    this.gender = null;
  }

  next() {
    this.currentQuestion++;
    const regex = new RegExp(`^${this.gender}|any`);
    const questions = this.questions.filter((q) => regex.test(q.asObject().gender));
    return questions[this.currentQuestion];
  }

  getLength() {
    // we assume that men and women have equal number of questions
    // so we use male questions for length (why not?)
    return this.questions.filter((q) => /^male|any/.test(q.asObject().gender)).length;
  }

  setGender(gender) {
    this.gender = gender;
  }
}

const metaQuestions = [
  new MetaQuestion('gender', {
    answers: [
      'Мужской',
      'Женский',
    ],
    image: 'http://placehold.it/100/ff0000',
    gender: 'any',
    question: 'Твой пол:',
    values: ['male', 'female'],
  }),
  new MetaQuestion('location', {
    answers: [
      'Москва',
      'Санкт-Петербург',
    ],
    image: 'http://placehold.it/100/ff0000',
    gender: 'any',
    question: 'Откуда ты?',
    values: ['msk', 'spb'],
  }),
];

module.exports = {
  Question,
  QuestionsList,
};
